import React from 'react';
import {cn} from '@/lib/utils';
import {Typography} from '@/components/ui/typography';
import {Button} from '@/components/ui/button';
import Link from 'next/link';


type DummyBoxProps = {
    title?: string;
    subtitle?: string;
    buttonText?: string;
    buttonPath?: string;
    className?: string;
}

const DummyBox = (props: DummyBoxProps) => {
    return (
        <div className={cn('py-4 px-6 backdrop-blur-[4px] bg-white flex items-center justify-center flex-col gap-4', props.className)}>
            <div>
                {props.title ? (
                    <Typography variant="h5" className="text-center">
                        {props.title}
                    </Typography>
                ) : null}
                {props.subtitle ? (
                    <Typography variant="p" className="text-center">
                        {props.subtitle}
                    </Typography>
                ) : null}
            </div>

            {(props.buttonText && props.buttonPath) ? (
                <Link passHref href={props.buttonPath}>
                    <Button variant="secondary" size="sm" asChild>
                        <a>
                            {props.buttonText}
                        </a>
                    </Button>
                </Link>
            ) : null}
        </div>
    )
};

export default DummyBox;
